import { Injectable } from '@angular/core';
import { ActiveCartService, CartStateSnapshotService } from '@cart/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Pos } from '@shop/const';
import { OccShopService, ShopActions } from '@shop/data-access';
import { EMPTY, Observable, combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class ShopListEffects {
  loadShopList$: Observable<ShopActions.LoadShopListSuccess | ShopActions.LoadShopListFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(ShopActions.LOAD_SHOPS_LIST),
      switchMap(() =>
        combineLatest({
          cartId: this.activeCartService.getActiveCartId(),
        }).pipe(take(1)),
      ),
      filter(({ cartId }) => !!cartId),
      switchMap(({ cartId }) => {
        if (this.cartStateSnapshotService.previousCartId === cartId) return EMPTY;

        return this.occShopService.loadShopList(cartId).pipe(
          map((data: Pos[]) => {
            return new ShopActions.LoadShopListSuccess(data);
          }),
          catchError((error) => {
            return of(new ShopActions.LoadShopListFail(error));
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occShopService: OccShopService,
    private activeCartService: ActiveCartService,
    private cartStateSnapshotService: CartStateSnapshotService,
  ) {}
}
